import { render, staticRenderFns } from "./BasePushEditorial.vue?vue&type=template&id=9da0803c&scoped=true&"
import script from "./BasePushEditorial.vue?vue&type=script&lang=js&"
export * from "./BasePushEditorial.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&lang=css&"
import style1 from "./BasePushEditorial.vue?vue&type=style&index=1&id=9da0803c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da0803c",
  null
  
)

export default component.exports